// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"db6968a1","46":"196c9e0f","182":"e64fa3f3","315":"5ed041e2","488":"af7a0b95","859":"195d171f"}[chunkId] + ".chunk.js";
};